module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"lastCollected":"Last collection"},"de":{"lastCollected":"Letzte Leerung"},"fr":{"lastCollected":"Dernière collection"},"it":{"lastCollected":"Ultimo svuotamento"}}')
  delete Component.options._Ctor
}
